import React from 'react'
import { TransitionGroup, Transition } from 'react-transition-group'
import styled from 'styled-components'
import Brightness from '../scripts/Brightness'

import { AvailableCategories } from '../scripts/AvailableCategories'
import CategoryIcons from '../assets/CategoryIcons'


class CategoryInfoHeader extends React.PureComponent {
  constructor(...args) {
    super(...args)
    this.state = {
      activeCatName: this.props.categoryName,
      activeCategory: this.props.categoryIcon,
      categories: AvailableCategories,
      categoryIcons: CategoryIcons,
    }

    this.updateCategory = this.updateCategory.bind(this)
  }

  updateCategory() {
    console.log(this.props.categoryName)
    if ( this.props.categoryName !== this.state.activeCatName ) {
      this.setState({
        activeCatName: this.props.categoryName
      })
    }
  }

  componentDidUpdate() {
    this.updateCategory()
  }

  render() {

    const CategoryName = ({in: inProp, catName}) => {

      const duration = 500

      const defaultStyles = {
        transition:  `transform ${duration}ms ease-in-out`,
        transform: 'translateX(100%)'
      }

      const transitionStyles = {
         entering: {
           transform: 'translateX(-100%)'
         },
         entered: {
           transform: 'translateX(0%)'
         },
         exiting: {
           transform: 'translateX(0%)'
         },
         exited: {
           transform: 'translateX(-100%)'
         }
     }

     let myIn = false

     if (catName === this.state.activeCatName) {
       myIn = true
     }

     return (
        <Transition in={myIn} timeout={{enter:0, exit:300}} >
          {(state) => (
            <h1 style={{
              ...defaultStyles,
              ...transitionStyles[state]
            }}>
              {catName}
            </h1>
          )}
        </Transition>
      )
    }

    const CategoryNameBackground = Brightness(this.props.themeStyles.subNavBackground, 0.4)

    const CatIconStyles = styled.span`
      border-right: solid 1px ${this.props.themeStyles.borderColor};
      background-color: ${this.props.themeStyles.mainColor};

      svg {
        * {
          fill: white;
        }
      }
    `

    const CategoryNameStyles = styled.span`
      background-color: ${CategoryNameBackground};
    `

    const IconContainer = (props) => (
      <CatIconStyles id="catIcon">
        <CategoryIcons icon={props.icon}/>
      </CatIconStyles>
    )

    return (
      <div id="categoryInfo">
        <div className="catHeaderText">
          {this.props.mobile === false &&
            <IconContainer icon={this.props.categoryIcon} />
          }
          <CategoryNameStyles className="categoryName">
            <TransitionGroup>
              {this.state.categories.map((cat, idx) => {
                return <CategoryName key={idx} catName={cat.name} />
              })}
              <CategoryName key="allCat" catName="All Library Courses" />
            </TransitionGroup>
          </CategoryNameStyles>
        </div>
      </div>
    )

  }


}

export default CategoryInfoHeader
